import * as Views from "./views";

const Module = {
    name: "cashflowattributionrules",
    defaultRoutePath: "/cashflows/cashflowattributionrule",
    menuItemScope: "cashflows",
    menuItemName: "cashflowattributionrules",
    routes: [
        {
            path: "/cashflows/cashflowattributionrule",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
    ],

}

export default Module;
